import { useContext } from 'react';
import { UploaderContext } from './UploaderContext';

export function useUploader() {
    const ctx = useContext(UploaderContext);
    return ctx;
}
